var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroSvgTopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 187,
    viewBox: "0 0 199 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.8-401c-18.9 74.8-20.4 156.5 20.4 228.8 26 46.1 65 83.4 112.2 107.2a266.2 266.2 0 00-151.1 35.2C68.6 9.7 27 76.6 6 146.5l-2.9 10L0 167.7l32.5 8.9a272.4 272.4 0 00207.2-25.4c63.9-36.8 115.7-126.7 134.2-192.7v-.3c17.8-66.4 19-170-17.4-234.2-35-62-93.2-105.2-156.8-124.9L158.8-412l-3 11zm69.6 534c0-.2 0 0 0 0z",
    fill: "#5700FF"
  })));
}
export default SvgHeroSvgTopRight;